import {jsonObject} from 'typedjson';

import {LoraPacket} from '@/model/lora/LoraPacket/LoraPacket';
import {LoraPacketUplinkJoinRequest} from '@/model/lora/LoraPacket/LoraPacketUplinkJoinRequest';
import {LoraPacketUplinkData} from '@/model/lora/LoraPacket/LoraPacketUplinkData';
import {LoraPacketUplink} from '@/model/lora/LoraPacket/LoraPacketUplink';
import {LoraPacketDownlink} from '@/model/lora/LoraPacket/LoraPacketDownlink';

import {
  FrequencyPlanChannel,
  FskFrequencyPlanChannel,
  MultiSfFrequencyPlanChannel,
  StdFrequencyPlanChannel,
} from '@/model/lora/FrequencyPlanChannel';

// https://github.com/JohnWeisz/TypedJSON/issues/139
// https://github.com/JohnWeisz/TypedJSON/blob/master/spec/polymorphism-root-abstract-class.spec.ts
jsonObject({knownTypes: [LoraPacketUplink, LoraPacketDownlink, LoraPacketUplinkJoinRequest, LoraPacketUplinkData]})(LoraPacket);
jsonObject({knownTypes: [MultiSfFrequencyPlanChannel, StdFrequencyPlanChannel, FskFrequencyPlanChannel]})(FrequencyPlanChannel);
